import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getBrandPriceCode, getBrandStorePackage } from "../../../services/StorePriceCode/getPriceCode";
import StorePackageStatusChange from "./StorePackageStatusChange";
import StorePackageAddModal from "./StorePackageAddModal";
import AdminMenu from "../../AdminMenu";

const StoreConfigPackage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id ,StoreData} = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [storePackageAddModalVisible, setStorePackageAddModalVisible] =
    useState(false);
  const [brandPackageCodeValue, setBrandPackageCodeValue] = useState(null);
  const [selectedStorePackageValue, setSelectedStorePackageValue] =
    useState(null);
      const [loading, setLoading] = useState(false);

  const { brandProfileData, userProfileRole } = getUserData();
  let brandId = brandProfileData.id;

  let userRole = userProfileRole;

  const fetchPriceCode = () => {
    
    getBrandPriceCode(brandId)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setSelectedStorePackageValue(res.packages);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

 

  const fetchBrandStorePackage = () => {
    setLoading(true);
    getBrandStorePackage(brandId, id)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setPackageData(res);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
   
  useEffect(() => {
    fetchPriceCode();
    fetchBrandStorePackage();
  }, []);

  const receiveDataFromBrandStorePackageStatusChange = ({success}) => {
    if (success) {
      fetchPriceCode();
      fetchBrandStorePackage();
    }
  };
  const renderStorePackageCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Package Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.packageDTO.name}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status === true ? "Active" : "DeActive"}{" "}
                    </p>
                  </div>
                  {userRole === "BY_FRANCHISE_ADMIN" ? (
                    ""
                  ) : (
                    <StorePackageStatusChange
                      status={item.status}
                      sendDataToStoreConfig={
                        receiveDataFromBrandStorePackageStatusChange
                      }
                      editData={item}
                      brandId={brandId}
                      storeId={id}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Package
              </p>
            </div>
          </div>
          {userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => {
                setStorePackageAddModalVisible(true);
                setBrandPackageCodeValue(selectedStorePackageValue);
              }}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : packageData?.length > 0 ? (
          <div>
            <div>{renderStorePackageCardItem(packageData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Package Data Present</p>
          </div>
        )}
      </div>
      <StorePackageAddModal
        storePackageAddModalVisible={storePackageAddModalVisible}
        setStorePackageAddModalVisible={setStorePackageAddModalVisible}
        sendDataToStoreConfig={receiveDataFromBrandStorePackageStatusChange}
        brandId={brandId}
        brandPackageCodeValue={brandPackageCodeValue}
        storeId={id}
        packageData={packageData}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreConfigPackage;
